// extracted by mini-css-extract-plugin
export var footer = "_r8-0";
export var inherit = "_r8-1";
export var input = "_r8-2";
export var modalContent = "_r8-3";
export var quillEditor = "_r8-4";
export var subtitle = "_r8-5";